import React, { useEffect, useRef, useState } from "react";
import Logo from "../../../assets/images/logo.svg";
import { logout } from "../../../actions/authActions";
import { getNotificaion } from "../../../actions/notificationActions";
import IndiaFlag from "../../../assets/images/in.svg";
import JapanFlag from "../../../assets/images/jp.svg";
import LeftNavigation from "../navigation_v2/leftNavigationContainer";
import {
	Layout,
	Avatar,
	Modal,
	Select,
	Button,
	Affix,
	Badge,
	Dropdown,
	Menu,
	Divider,
} from "antd";
import {
	ExportOutlined,
	ClockCircleOutlined,
	InfoCircleOutlined,
} from "@ant-design/icons";
import i18next from "i18next";
import cookies from "js-cookie";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import "./applicationLayout.css";
import Notification from "../notification/notification";
import {
	EditPenOnPaperIcon,
	PeopleIcon,
	SettingGearIcon,
	LogoutIcon,
	NotificationBellIcon,
	DocumentsIcon,
} from "../icons";
import { timeFormat } from "../notification/notificationUtility";
import GalkButton from "../component/button";
const { Content, Sider } = Layout;

// const internshipPages = navigationsForGalkRecruit.map((item, i) => {
// 	return {
// 		title: `${t(item.translateKey)}`,
// 		href: `/Internship${item.relativeUrl}`,
// 		icon: item.icon,
// 		key: item.key,
// 	};
// });

const ApplicationLayout = ({
	company,
	userName,
	children,
	history,
	logout,
	profilePicture,
	notifications,
	getNotificaion,
}) => {
	const { t } = useTranslation();
	const [notificationToShow, setNotificationToShow] = useState(null);
	const currentLanguageCode = cookies.get("i18next") || "en";
	const _logout = (e) => {
		e.stopPropagation();
		logout(history);
	};

	const unsubscribeFromNotification = useRef(null);

	const handleLanguageChange = (languageCode) => {
		i18next.changeLanguage(languageCode);
	};

	useEffect(() => {
		if (company?.id)
			unsubscribeFromNotification.current = getNotificaion(company?.id);
		return () => {
			let unsubscribe = unsubscribeFromNotification.current;
			if (typeof unsubscribe == typeof Function) {
				unsubscribe();
			}
		};
	}, [company?.id]); // eslint-disable-line react-hooks/exhaustive-deps

	const accountSettingMenu = (
		<div className="headerNav_logoMenu_container">
			<div className="headerNav_logoMenu_container_row1">
				<div className="logoRow">
					<Avatar shape="circle" size={54} src={company.logo} />
				</div>
				<div className="NameRow">
					<div className="name">{company.nameInEnglish}</div>
					<div className="address">{company.address}</div>
				</div>
				<Link to={"/AccountSetting/Companyprofile"}>
					<div className="infoEditRow">
						<EditPenOnPaperIcon width={20} height={20} />
						<div className="menuText">
							{t("accountSetting_companyInfo_tabHeader")}
						</div>
					</div>
				</Link>
			</div>
			<div className="headerNav_logoMenu_container_row2">
				<Link to={"/AccountSetting/TeamMembers"} className="menu1">
					<PeopleIcon width={20} height={20} />
					<div className="menuText">
						{t("accountSetting_memberInfo_tabHeader")}
					</div>
				</Link>
				<Link to={"/AccountSetting/Myprofile"} className="menu2">
					<SettingGearIcon width={20} height={20} />
					<div className="menuText">
						{t("homeRoot_appModuleOption_accountSetting")}
					</div>
				</Link>
				<Link to={"/AccountSetting/Documents"} className="menu3">
					<DocumentsIcon width={20} height={20} />
					<div className="menuText">{t("nav_document_download")}</div>
				</Link>
				<div className="menu4" onClick={_logout}>
					<LogoutIcon width={20} height={20} />
					<div className="menuText">{t("logout")}</div>
				</div>
			</div>
		</div>
	);

	const closeNotificationDetails = () => {
		setNotificationToShow(null);
	};
	const shoNotificationDetails = (notification) => {
		setNotificationToShow(notification);
	};

	const notificationList = (
		<Notification shoNotificationDetails={shoNotificationDetails} />
	);

	return (
		<Layout>
			<Affix offsetTop={0}>
				<div className="applicationLayout-header">
					<Link to={"/Internship/projectinformation"}>
						<div className="applicationLayout-header-logo">
							<img src={Logo} alt="Logo" />
						</div>
					</Link>
					<div className="applicationLayout-header-menu">
						<div style={{ cursor: "pointer" }}>
							<Select
								defaultValue={currentLanguageCode}
								bordered={false}
								onChange={handleLanguageChange}
							>
								<Select.Option value="en">
									<img src={IndiaFlag} style={{ verticalAlign: "unset" }} />
								</Select.Option>
								<Select.Option value="ja">
									<img src={JapanFlag} style={{ verticalAlign: "unset" }} />
								</Select.Option>
							</Select>
						</div>
						<div style={{ cursor: "pointer", paddingTop: 10 }}>
							<Dropdown
								overlay={notificationList}
								placement="bottomRight"
								arrow
								trigger={["click"]}
							>
								<Avatar
									shape="circle"
									size={40}
									src={<NotificationBellIcon width={32} height={32} />}
								/>
								{/* <div className="notificationAvatar">
									<NotificationBellIcon width={32} height={32} />
								</div> */}
							</Dropdown>
							{notificationToShow && (
								<Modal
									title={
										<div id="headId">
											<div>
												<InfoCircleOutlined />
											</div>
											<div>{t("notificationDetails_modalHeader")}</div>
										</div>
									}
									footer={[
										<GalkButton
											key="submit"
											type="primary"
											width={90}
											onClick={closeNotificationDetails}
										>
											OK
										</GalkButton>,
									]}
									visible={true}
									onCancel={closeNotificationDetails}
								>
									<div id="titleId">{notificationToShow?.title}</div>
									<div className="timeId">
										<ClockCircleOutlined /> &nbsp;
										{timeFormat(notificationToShow?.date.toDate())}
									</div>
									<div className="textId">{notificationToShow?.text}</div>
								</Modal>
							)}
						</div>
						<div
							style={{
								cursor: "pointer",
								borderRadius: "50%",
								border: "1px solid #D0D5DD",
							}}
						>
							<Dropdown
								overlay={accountSettingMenu}
								placement="bottomRight"
								arrow
								trigger={["click"]}
							>
								<Avatar shape="circle" size={40} src={company.logo} />
							</Dropdown>
						</div>
					</div>
				</div>
			</Affix>
			<Layout>
				<Sider width={248} className="applicationLayout-sider">
					<LeftNavigation />
				</Sider>
				<Layout
					style={{
						padding: 0,
						backgroundColor: "#f2f2f2 !important",
					}}
				>
					<Content className="applicationLayout-content">{children}</Content>
				</Layout>
			</Layout>
		</Layout>
	);
};

const mapStateToProps = (state) => ({
	userId: state.firebase.auth.uid,
	userName: state.firebase.profile.name,
	company: state.company.company,
	profilePicture: state.company.companyUserProfilePicture,
	notifications: state.notifications,
});

export default connect(mapStateToProps, { logout, getNotificaion })(
	withRouter(ApplicationLayout)
);
